// src/components/UnauthLanding.jsx

import React from 'react';
import { LogIn } from 'lucide-react';

const UnauthLanding = ({ onLoginClick }) => (
    <div className="h-screen bg-slate-900 flex flex-col items-center justify-center p-6 relative overflow-hidden">
        {/* Background Accents */}
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-brand-primary/20 rounded-full blur-[100px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-purple-500/20 rounded-full blur-[100px]" />

        <div className="relative z-10 text-center max-w-md w-full">
            <div className="mb-8">
                <span className="text-4xl font-black text-white tracking-wider">ERI</span>
                <span className="text-4xl font-light text-brand-primary ml-2">HUB</span>
            </div>
            
            <div className="bg-white/10 backdrop-blur-lg border border-white/10 p-8 rounded-3xl shadow-2xl">
                <h2 className="text-2xl font-bold text-white mb-2">Welcome Back</h2>
                <p className="text-slate-400 mb-8">Please log in to access your dashboard.</p>
                
                <button 
                    onClick={onLoginClick}
                    className="w-full py-4 bg-brand-primary hover:bg-brand-dark text-white rounded-xl font-bold transition-all shadow-lg flex items-center justify-center gap-2"
                >
                    <LogIn size={20} /> Log In to Portal
                </button>
            </div>
            
            <p className="mt-8 text-slate-500 text-xs">
                Restricted Access. Authorized Personnel Only.
            </p>
        </div>
    </div>
);

export default UnauthLanding;